<template>
  <a
    v-show="documentUrl"
    :href="documentUrl"
    target="_blank"
    rel="noopener noreferrer"
    title="Documentation"
    class="sc3-button sc3-button-small sc3-button-grey sc3-button-square-medium-height"
    :class="{
      'sc3-button-bottom-aligned': isFirstIndicatorOverlayRow,
      'sc3-button-top-aligned': !isFirstIndicatorOverlayRow
    }"
  ><i class="fas fa-fw fa-info"></i></a>
</template>

<script lang="ts" setup>
  import { toRefs, computed } from 'vue';
  import { INDICATORS_AND_OVERLAYS_ARRAY } from '@/enums/indicators-and-overlays';

  const props = defineProps<{
    indicatorOrOverlayName: string;
    isFirstIndicatorOverlayRow: boolean;
  }>();
  const { indicatorOrOverlayName, isFirstIndicatorOverlayRow } = toRefs(props);
  const documentUrl = computed(() => {
    const definition = INDICATORS_AND_OVERLAYS_ARRAY.find(def => def.name === indicatorOrOverlayName.value);

    if (!definition) {
      return '';
    }

    return definition.documentationURL;
  });
</script>
